<template>
  <form
    class="ecommerce-form action-buttons-fixed"
    @submit.prevent="submitForm"
    novalidate
  >
    <div class="row">
      <div class="col">
        <section class="card card-modern card-big-info">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-2-5 col-xl-1-5">
                <i class="card-big-info-icon bx bx-dollar-circle"></i>
                <h2 class="card-big-info-title">Billing Info</h2>
                <p class="card-big-info-desc">
                  Add here the customer billing info with all details and
                  necessary information.
                </p>
              </div>
              <div class="col-lg-3-5 col-xl-4-5">
                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Ime</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      v-model="user.firstName"
                    />

                    <form-error
                      :model="$v.user.firstName"
                      :dirty="$v.$dirty"
                      label="Ime"
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Prezime</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      v-model="user.lastName"
                    />

                    <form-error
                      :model="$v.user.lastName"
                      :dirty="$v.$dirty"
                      label="Prezime"
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Telefon</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      v-model="user.phoneNumber"
                    />

                    <form-error
                      :model="$v.user.phoneNumber"
                      :dirty="$v.$dirty"
                      label="Telefon"
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    Uloge
                  </label>
                  <div class="col-lg-7 col-xl-6">
                    <div>
                      <treeselect
                        v-model="user.userGroups"
                        :multiple="true"
                        :options="roles"
                        :show-count="true"
                        placeholder="Izaberite uloge"
                      />
                    </div>
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3" v-if="loaded">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Kompanija</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <treeselect
                      v-model="user.companyId"
                      loadingText="Učitavanje..."
                      :noResultsText="companyNoResultsText"
                      searchPromptText="Unesite najmanje 3 karaktera"
                      :load-options="loadCompanies"
                      :async="true"
                      :default-options="companyOptions"
                      :options="companyOptions"
                      :cache-options="false"
                      placeholder="Izaberite kompaniju"
                      @select="onCompanySelect"
                    />
                    <form-error
                      :model="$v.user.companyId"
                      :dirty="$v.$dirty"
                      label="Kompanija"
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    Kontakt osoba?
                  </label>
                  <div class="col-lg-7 col-xl-6">
                    <div class="checkbox-custom checkbox-default">
                      <input
                        type="checkbox"
                        v-model="user.isContactPerson"
                        id="is-contact-person"
                      />
                      <label for="is-contact-person"></label>
                    </div>
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Titula</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      v-model="user.personProfessionalTitle"
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Država</label
                  >
                  <div class="col-lg-7 col-xl-6" v-if="loaded">
                    <treeselect
                      v-model="user.countryId"
                      loadingText="Učitavanje..."
                      noResultsText="Nema rezultata"
                      searchPromptText="Unesite državu"
                      :load-options="loadCountries"
                      :default-options="countries"
                      :async="true"
                      :options="countries"
                      placeholder="Izaberite državu"
                      @select="handleCountrySelect"
                    />

                    <form-error
                      :model="$v.user.countryId"
                      :dirty="$v.$dirty"
                      label="Država"
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Grad</label
                  >
                  <div class="col-lg-7 col-xl-6" v-if="loaded">
                    <treeselect
                      v-model="user.townId"
                      loadingText="Učitavanje..."
                      noResultsText="Nema rezultata"
                      searchPromptText="Unesite grad"
                      :load-options="loadTowns"
                      :cache-options="false"
                      :async="true"
                      :options="towns"
                      :default-options="towns"
                      placeholder="Izaberite grad"
                      @select="setZipCode"
                    />

                    <form-error
                      :model="$v.user.townId"
                      :dirty="$v.$dirty"
                      label="Grad"
                    />
                  </div>
                </div>


                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    Interesna područja
                  </label>
                  <div class="col-lg-7 col-xl-6">
                    <vue-select
                      :options="interestsAreas"
                      v-model="interestsAreasIds"
                      :close-on-select="false"
                      :multiple="true"
                      track-by="id"
                      label="title"
                      placeholder="Izaberite interesna područja"
                    >
                      <template slot="noOptions">Lista je prazna</template>
                      <template slot="noResult">Nema rezultata prema zadanim parametrima</template>
                    </vue-select>
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-primary mt-2"
                      @click="selectAllInterestsAreas"
                    >
                      Odaberi sve
                    </button>
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Adresa 1</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      v-model="user.address_1"
                    />

                    <form-error
                      :model="$v.user.address_1"
                      :dirty="$v.$dirty"
                      label="Adresa 1"
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Adresa 2</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      v-model="user.address_2"
                    />
                  </div>
                </div>
                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    Prima sve notifikacije?
                  </label>
                  <div class="col-lg-7 col-xl-6">
                    <div class="checkbox-custom checkbox-default">
                      <input
                        type="checkbox"
                        v-model="user.receivesAllNotifications"
                        id="can-view-prices"
                      />
                      <label for="can-view-prices"></label>
                    </div>
                  </div>
                </div>
                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    Može vidjeti finansije?
                  </label>
                  <div class="col-lg-7 col-xl-6">
                    <div class="checkbox-custom checkbox-default">
                      <input
                        type="checkbox"
                        v-model="user.canViewFinances"
                        id="can-view-prices"
                      />
                      <label for="can-view-prices"></label>
                    </div>
                  </div>
                </div>
                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    Može vidjeti cijene?
                  </label>
                  <div class="col-lg-7 col-xl-6">
                    <div class="checkbox-custom checkbox-default">
                      <input
                        type="checkbox"
                        v-model="user.canViewPrices"
                        id="can-view-prices"
                      />
                      <label for="can-view-prices"></label>
                    </div>
                  </div>
                </div>
                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    Potrebno odobriti narudžbu?
                  </label>
                  <div class="col-lg-7 col-xl-6">
                    <div class="checkbox-custom checkbox-default">
                      <input
                        type="checkbox"
                        v-model="user.orderApprovalRequired"
                        id="order-approval-required"
                        @change="onChangeOrderApprovalRequired"
                      />
                      <label for="order-approval-required"></label>
                    </div>
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    Može odobriti narudžbu?
                  </label>
                  <div class="col-lg-7 col-xl-6">
                    <div class="checkbox-custom checkbox-default">
                      <input
                        type="checkbox"
                        v-model="user.canApproveOrder"
                        id="can-approve-order"
                        @change="onChangeCanApproveOrder"
                      />
                      <label for="can-approve-order"></label>
                    </div>
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    for="can-view-all-orders-within-company"
                  >
                    Može vidjeti sve narudžbe unutar kompanije?
                  </label>
                  <div class="col-lg-7 col-xl-6">
                    <div class="checkbox-custom checkbox-default">
                      <input
                        type="checkbox"
                        v-model="user.canViewAllOrdersWithinCompany"
                        id="can-view-all-orders-within-company"
                      />
                      <label for="can-view-all-orders-within-company"></label>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <section class="card card-modern card-big-info">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-2-5 col-xl-1-5">
                <i class="card-big-info-icon bx bx-mail-send"></i>
                <h2 class="card-big-info-title">Shipping Info</h2>
                <p class="card-big-info-desc">
                  Add here the customer shipping info with all details and
                  necessary information.
                </p>
              </div>
              <div class="col-lg-3-5 col-xl-4-5">
                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Same as billing</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <div class="checkbox">
                      <label class="my-2">
                        <input
                          type="checkbox"
                          v-model="sameAsBilling"
                          data-bs-toggle="collapse"
                          data-bs-target=".shipping-fields-wrapper"
                        />
                        Check this box to use same information as billing for
                        shipping.
                      </label>
                    </div>
                  </div>
                </div>

                <div class="shipping-fields-wrapper collapse show">
                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Ime</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        v-model="shippingInfo.firstName"
                      />

                      <form-error
                        :model="$v.shippingInfo.firstName"
                        :dirty="$v.$dirty"
                        label="Ime"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Prezime</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        v-model="shippingInfo.lastName"
                      />

                      <form-error
                        :model="$v.shippingInfo.lastName"
                        :dirty="$v.$dirty"
                        label="Prezime"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Telefon</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        v-model="shippingInfo.phone"
                      />

                      <form-error
                        :model="$v.shippingInfo.phone"
                        :dirty="$v.$dirty"
                        label="Telefon"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Država</label
                    >
                    <div class="col-lg-7 col-xl-6" v-if="loaded">
                      <treeselect
                        v-model="shippingInfo.countryId"
                        loadingText="Učitavanje..."
                        noResultsText="Nema rezultata"
                        searchPromptText="Unesite državu"
                        :load-options="loadCountries"
                        :async="true"
                        :options="countries"
                        :default-options="countries"
                        placeholder="Izaberite državu"
                        @select="handleCountrySelect"
                      />

                      <form-error
                        :model="$v.shippingInfo.countryId"
                        :dirty="$v.$dirty"
                        label="Država"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Grad</label
                    >
                    <div class="col-lg-7 col-xl-6" v-if="loaded">
                      <treeselect
                        v-model="shippingInfo.townId"
                        loadingText="Učitavanje..."
                        noResultsText="Nema rezultata"
                        searchPromptText="Unesite grad"
                        :load-options="loadShippingTowns"
                        :async="true"
                        :options="towns"
                        :default-options="towns"
                        placeholder="Izaberite grad"
                        @select="setShippingZipCode"
                      />

                      <form-error
                        :model="$v.shippingInfo.townId"
                        :dirty="$v.$dirty"
                        label="Grad"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Zip kôd</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        v-model="shippingInfo.zipCode"
                      />

                      <form-error
                        :model="$v.shippingInfo.zipCode"
                        :dirty="$v.$dirty"
                        label="Zip kôd"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Adresa 1</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        v-model="shippingInfo.address_1"
                      />

                      <form-error
                        :model="$v.shippingInfo.address_1"
                        :dirty="$v.$dirty"
                        label="Adresa 1"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Adresa 2</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        v-model="shippingInfo.address_2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <section class="card card-modern card-big-info">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-2-5 col-xl-1-5">
                <i class="card-big-info-icon bx bx-user-circle"></i>
                <h2 class="card-big-info-title">Account Info</h2>
                <p class="card-big-info-desc">
                  Add here the customer account info with all details and
                  necessary information.
                </p>
              </div>
              <div class="col-lg-3-5 col-xl-4-5">
                <div
                  class="form-group row align-items-center pb-3"
                  :class="{ 'has-danger': emailExists }"
                >
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >E-mail</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <input
                      type="email"
                      class="form-control form-control-modern"
                      v-model="user.email"
                      @blur="checkIfEmailExists"
                    />
                  </div>
                </div>
                <div
                  class="form-group row align-items-center pb-3"
                  :class="{ 'has-danger': usernameExists }"
                >
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Korisničko ime</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      v-model="user.userName"
                      @blur="checkIfUsernameExists"
                      />
                  </div>
                </div>
                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Lozinka</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <div class="d-flex gap-2">
                      <input
                        :type="passwordFieldType"
                        class="form-control form-control-modern"
                        v-model="password"
                        autocomplete="new-password"
                      />
                      <button type="button" class="btn btn-primary flex-shrink-0" @click="generatePassword">
                        Generiši lozinku
                      </button>
                    </div>

                    <form-error
                      :model="$v.password"
                      :dirty="$v.$dirty"
                      label="Lozinka"
                    />
                  </div>
                </div>
                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Potvrda lozinke</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <input
                      :type="passwordFieldType"
                      class="form-control form-control-modern"
                      v-model="confirmPassword"
                    />

                    <form-error
                      :model="$v.confirmPassword"
                      :dirty="$v.$dirty"
                      label="Potvrda lozinke"
                    />
                  </div>
                </div>

                <div v-if="user.isAccountVerified == false" class="w-100 d-flex justify-content-end">
                  <button
                    class="btn btn-primary btn-sm mt-5 font-weight-semibold btn-py-2 modal-with-zoom-anim mr-2"
                    style="margin-right: 10px;"
                    @click.stop.prevent="activateUser"
                  >
                    Aktiviraj
                  </button>
                  <button
                    class="btn btn-primary btn-sm mt-5 font-weight-semibold btn-py-2 modal-with-zoom-anim mr-2"
                    @click.stop.prevent="sendNotification"
                  >
                    Resend poveznice za aktivaciju
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="action-buttons d-flex justify-content-between">
      <div class="d-flex gap-3">
        <button
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#delete-modal"
          class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
        >
          <i class="bx bx-trash text-4 me-2"></i> {{ translations.delete }}
        </button>
        <button
          v-if="user.b2B && !user.deactivated"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#deactivate-modal"
          class="deactivate-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
        >
          {{ translations.deactivate }}
        </button>
        <button 
          v-if="user.b2B && user.deactivated"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#activate-modal"
          class="activate-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
        >
          {{ translations.activate }}
        </button>
      </div>
      <div class="d-flex gap-3">
        <router-link
          exact
          :to="{ name: 'Users' }"
          class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
        >
          {{ translations.cancel }}
        </router-link>
        <button
          type="submit"
          class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          data-loading-text="Loading..."
          :disabled="usernameExists || emailExists"
        >
          <i class="bx bx-save text-4 me-2"></i> Spremi
        </button>
      </div>
    </div>
    <modal id="delete-modal">
      <h5 slot="header">
        <strong>{{ translations.deleteUser }}</strong>
      </h5>
      <div slot="body">
        <span v-html="modalText"> </span>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.prevent.stop="deleteUser"
              data-bs-dismiss="modal"
            >
              {{ translations.yes }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <modal id="deactivate-modal">
      <h5 slot="header">
        <strong>Deaktiviraj korisnika</strong>
      </h5>
      <div slot="body">
        <span v-html="modalTextDeactivate"> </span>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.prevent.stop="deactivateUser"
              data-bs-dismiss="modal"
            >
              {{ translations.yes }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <modal id="activate-modal">
      <h5 slot="header">
        <strong>Aktiviraj korisnika</strong>
      </h5>
      <div slot="body">
        <span v-html="modalTextActivate"> </span>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.prevent.stop="activateUser"
              data-bs-dismiss="modal"
            >
              {{ translations.yes }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>
  </form>
</template>

<script>
import VueSelect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import api from '@/services/api';
import { translations } from '@/mixins';
import FormError from '../shared/form-errors/FormError.vue';
import Modal from '../shared/modal/Modal.vue';

import validations from './validation-schema/edit';
import { debounce } from 'lodash';

const { shippingInfo, password, confirmPassword } = validations;

delete validations.shippingInfo;
delete validations.password;
delete validations.confirmPassword;

export default {
  name: 'EditUser',
  components: {
    VueSelect,
    Treeselect,
    FormError,
    Modal,
  },
  mixins: [translations],
  validations: {
    password,
    confirmPassword,
    user: {
      ...validations,
    },
    shippingInfo,
  },
  data() {
    return {
      password: '',
      confirmPassword: '',
      // this will change to text when button to generate password is clicked
      passwordFieldType: 'password',
      sameAsBilling: false,
      interestsAreasIds: [],
      roleIds: [],
      loaded: false,
      userId: undefined,
      usernameExists: false,
      emailExists: false,
      companySearchQuery: '',
      pendingCompanyCallbacks: [],
      companyOptions: []
    };
  },
  computed: {
    companyNoResultsText() {
      return this.companySearchQuery.length < 3
        ? 'Unesite najmanje 3 karaktera'
        : 'Nema rezultata';
    },
    modalText() {
      return this.translations.areYouSureUser.replace(
        '{user}',
        `<strong>${this.user.firstName} ${this.user.lastName}</strong>`
      );
    },
    modalTextDeactivate() {
      return this.translations.areYouSureUserDeactivate.replace(
        '{user}',
        `<strong>${this.user.firstName} ${this.user.lastName}</strong>`
      );
    },
    modalTextActivate() {
      return this.translations.areYouSureUserActivate.replace(
        '{user}',
        `<strong>${this.user.firstName} ${this.user.lastName}</strong>`
      );
    },
    companies() {
      return this.$store.getters.getCompanies.map((item) => {
        return {
          id: item.id,
          label: item.title,
          ...item,
        };
      });
    },
    countries() {
      return this.$store.getters.getCountries.map((item) => {
        return {
          label: item.title,
          ...item,
        };
      });
    },
    towns() {
      return this.$store.getters.getTowns.map((item) => {
        return {
          id: item.id,
          label: item.title,
          ...item,
        };
      });
    },
    shippingTowns() {
      return this.$store.getters.getShippingTowns;
    },
    user() {
      return this.$store.getters.getSelectedUser;
    },
    shippingInfo() {
      return this.$store.getters.getUserShippingInfo;
    },
    isFormValid() {
      return !this.$v.$invalid;
    },
    roles() {
      return this.$store.getters.getRolesSimplified.map(({ id, name }) => ({
        id,
        label: name,
      }));
    },
    interestsAreas() {
      return this.$store.getters.getInterestsAreas.map(({ id, title }) => ({ id, title }));
    },
  },
  methods: {
    selectAllInterestsAreas() {
      this.interestsAreasIds = [...this.interestsAreas];
    },
    onChangeCanApproveOrder() {
      this.user.orderApprovalRequired = false;
    },
    onChangeOrderApprovalRequired() {
      this.user.canApproveOrder = false;
    },
    getTowns(reset = true) {
      this.$store.dispatch('getTowns', { countryId: this.user.countryId });
      if (reset) this.user.townId = null;
    },
    getShippingTowns(reset = true) {
      this.$store.dispatch('getShippingTowns', {
        countryId: this.shippingInfo.countryId,
      });
      if (reset) this.shippingInfo.townId = null;
    },
    setZipCode({ id }) {
      this.zipCode = this.towns.find((town) => town.id === id).zipCode;
    },
    setShippingZipCode({ id }) {
      this.shippingInfo.zipCode = this.towns.find(
        (town) => town.id === id
      ).zipCode;
    },
    checkIfUsernameExists() {
      api.checkUsername({
        userId: this.userId,
        username: this.user.userName
      })
        .then((response) => {
          this.usernameExists = response.data.data;

          if (this.usernameExists)
            this.$toast.error('Korisničko ime se već koristi!');
        })
    },
    checkIfEmailExists() {
      api.checkEmail({
        userId: this.userId,
        email: this.user.email
      })
        .then((response) => {
          this.emailExists = response.data.data;

          if (this.emailExists)
            this.$toast.error('E-mail se već koristi!');
        })
    },
    submitForm() {
      this.$v.$touch();
      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      if (this.usernameExists || this.emailExists) {
        return;
      }

      const { user, sameAsBilling } = this;
      let { shippingInfo } = this;

      user.interestsAreas = this.interestsAreasIds.map(({ id }) => id);

      if (this.password) {
        user.password = this.password;
      }
      // Not required props

      if (sameAsBilling) {
        this.setZipCode({ id: this.user.townId });
        const {
          firstName,
          lastName,
          username,
          email,
          phoneNumber: phone,
          address_1,
          address_2,
          townId,
          zipCode,
          countryId,
        } = user;

        shippingInfo = {
          firstName,
          lastName,
          username,
          email,
          phone,
          address_1,
          address_2,
          townId,
          zipCode,
          countryId,
        };
      }
      
      shippingInfo.userId = parseInt(this.userId);

      Promise.all([
        api.updateUser(user),
        api.updateShippingInfoAdmin(shippingInfo),
      ])
        .then(() => {
          this.$toast.info('Uspješno ažurirano');
          this.$router.push({ name: 'Users' });
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
    deleteUser() {
      api
        .deleteUsers([this.user.id])
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Users' });
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
    activateUser() {
      api
        .activateUser(this.user.id)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$store.dispatch('getUser', this.userId)
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
    deactivateUser() {
      api
        .deactivateUser(this.user.id)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Users' });
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
    // Lazy loading data for treeselect component
    loadCountries({ callback, searchQuery }) {
      this.$store
        .dispatch('getCountries', {
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: searchQuery,
          sortBy: 'title',
        })
        .then(() => {
          callback(null, this.countries);
        });
    },
    onCompanySelect(company) {
      this.companyOptions = [company];
    },
    loadCompanies({ callback, searchQuery }) {
      this.companySearchQuery = searchQuery || '';

      if (this.companySearchQuery.length < 3) {
        callback(null, []);
        return;
      }

      this.pendingCompanyCallbacks.push(callback);
      this.searchCompanies();
    },
    searchCompanies: debounce(function () {
      const callbacks = this.pendingCompanyCallbacks;
      this.pendingCompanyCallbacks = [];

      this.$store
        .dispatch('getCompaniesV2', {
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: this.companySearchQuery,
          sortBy: 'title',
        })
        .then(() => {
          callbacks.forEach((cb) => cb(null, this.companies));
        })
        .catch((err) => {
          callbacks.forEach((cb) => cb(err));
        });
    }, 500),
    loadTowns({ callback, searchQuery }) {
      this.townId = null;

      this.$store
        .dispatch('getTowns', {
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: searchQuery,
          sortBy: 'title',
          countryId: this.countryId
        })
        .then(() => {
          callback(null, this.towns);
        });
    },
    loadShippingTowns({ callback, searchQuery }) {
      this.shippingInfo.townId = null;

      this.$store
        .dispatch('getTowns', {
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: searchQuery,
          sortBy: 'title',
          countryId: this.shippingInfo.countryId
        })
        .then(() => {
          callback(null, this.towns);
        });
    },
    handleCountrySelect({ id }) {
      this.$store.dispatch('getTowns', {
        isSortAscending: true,
        retrieveAll: true,
        sortBy: 'title',
        countryId: id,
      });
    },
    customLabel({ title }) {
      return title;
    },
    generatePassword() {
      const password = (Math.random() + 1).toString(36).substring(2);

      this.password = password;
      this.confirmPassword = password;

      this.passwordFieldType = 'text';
    },
    sendNotification() {
      api.resendVerificationMail(this.userId).then((response) => {
        this.$toast.info(response?.data?.info);
      })
    },
  },
  mounted() {
    this.$store.dispatch('getRolesSimplified');

    this.userId =  this.$route.params.id;

    this.$store.dispatch('getUser', this.userId).then((response) => {
      Promise.all([
        this.$store.dispatch('getCountries', {
          sortBy: 'title',
          isSortAscending: true,
          mustIncludeId: response.countryId,
        }),
        this.$store.dispatch('getTowns', {
          sortBy: 'title',
          isSortAscending: true,
          mustIncludeId: response.townId,
        }),
        this.$store.dispatch('getCompanies', {
          sortBy: 'title',
          isSortAscending: true,
          mustIncludeId: response.companyId,
        })
      ])
        .then(() => {
          this.companyOptions = this.companies.filter(
            ({ id }) => id === response.companyId
          );

          this.loaded = true;
          this.$store.dispatch('getInterestsAreas', { retrieveAll: true }).then((areas) => {
            this.interestsAreasIds = response.interestsAreas.map((area) => {
              return {
                id: area,
                title: areas.find(({ id }) => id === area).title
              };
            });
          });
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    });
    this.$store
      .dispatch('getShippingInfoForUser', this.userId)
      .then(() => {
        this.getShippingTowns(false);
      });

    this.$store.dispatch('getInterestsAreas', { retrieveAll: true });
  },
};
</script>
